import { render, staticRenderFns } from "./ExchangeList.vue?vue&type=template&id=68513552"
import script from "./ExchangeList.vue?vue&type=script&lang=js"
export * from "./ExchangeList.vue?vue&type=script&lang=js"
import style0 from "./ExchangeList.vue?vue&type=style&index=0&id=68513552&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports